import { StyleSheet } from 'react-native';
import React, { useEffect, useState } from 'react';
import { Box, Typography, Button, SxProps, Theme } from '@mui/material';
import { useThemeContext } from '../../hook/useThemeManager';
import { theme, ColorScheme } from '../../constants/theme';
import { FONT_ENUM } from '../../types/global/fonts.types';

interface ICustomSegmentedControl {
    onHandleClick: (tab: string, index: number) => void;
    tabs: string[];
    sx?: SxProps<Theme>;
    tabStyle?: React.CSSProperties;
    buttonStyle?: React.CSSProperties;
    initialIndex?: number;
    additionalDetails?: any[];
}

const ShortSegmentedControl: React.FC<ICustomSegmentedControl> = ({
    onHandleClick,
    tabs,
    sx,
    tabStyle,
    buttonStyle,
    initialIndex,
    additionalDetails,
}) => {
    const { themeStyle } = useThemeContext();
    const styles = dynamicStyles(themeStyle);
    const [currentIndex, setCurrentIndex] = useState(0);

    const handlePress = (tab: string, index: number) => {
        onHandleClick(tab, index);
        setCurrentIndex(index);
    };

    useEffect(() => {
        if (initialIndex) {
            setCurrentIndex(initialIndex);
        }
    }, [initialIndex]);
    return (
        <Box
            style={styles.navbar}
            sx={{
                justifyContent: { xs: 'center', sm: 'flex-start' },
                borderBottom: `0.5px solid ${theme[themeStyle].light_gray_text}`,
                borderTop: `0.5px solid ${theme[themeStyle].darkGray60}`,
                ...sx,
            }}>
            <Box style={{ ...styles.flexRow, ...tabStyle }}>
                {tabs.map((tab, index) => (
                    <Button
                        onClick={() => handlePress(tab, index)}
                        style={{ ...styles.navButton, ...buttonStyle }}
                        key={index}
                        sx={{
                            textTransform: 'none',
                            borderBottom:
                                currentIndex === index ? `1px solid ${theme[themeStyle].primary_orange}` : 'none',
                            transition: 'all 0.3 ease-in-out',
                        }}>
                        <Typography
                            style={{ ...styles.navText, display: 'inline' }}
                            sx={{
                                color:
                                    currentIndex === index
                                        ? theme[themeStyle].primary_white
                                        : theme[themeStyle].form_label,
                                transition: 'all 0.3 ease-in-out',
                            }}>
                            {tab}{' '}
                            {additionalDetails && additionalDetails[index] && (
                                <Typography
                                    style={{
                                        display: 'inline',
                                        fontFamily: FONT_ENUM.MAIN_MEDIUM,
                                        fontSize: 10,
                                        color: theme[themeStyle].grey,
                                    }}
                                    sx={{
                                        transition: 'all 0.3 ease-in-out',
                                    }}>
                                    {additionalDetails[index]}
                                </Typography>
                            )}
                        </Typography>
                    </Button>
                ))}
            </Box>
        </Box>
    );
};

const dynamicStyles = (colorScheme: ColorScheme) =>
    StyleSheet.create({
        text: {
            textAlign: 'left',
            fontSize: 24,
            fontStyle: 'normal',
            fontWeight: '600',
            color: theme[colorScheme].filters_white,
            fontFamily: FONT_ENUM.MAIN_BOLD,
        },
        navbar: {
            display: 'flex',
            alignItems: 'center',
            // minHeight: '60px',
            paddingTop: 10,
        },
        flexRow: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
        },
        navButton: {
            backgroundColor: theme[colorScheme].transparent,
            height: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            borderRadius: 0,
        },
        navText: {
            textAlign: 'center',
            fontSize: 14,
            fontStyle: 'normal',
            fontWeight: '600',
            fontFamily: FONT_ENUM.MAIN_BOLD,
            textTransform: 'capitalize',
        },
    });

ShortSegmentedControl.defaultProps = {
    tabs: ['tab1', 'tab2', 'tab3'],
};

export { ShortSegmentedControl };
